import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=2643a6a2&scoped=true&"
import script from "./not-found.vue?vue&type=script&lang=js&"
export * from "./not-found.vue?vue&type=script&lang=js&"
import style0 from "./not-found.vue?vue&type=style&index=0&id=2643a6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643a6a2",
  null
  
)

export default component.exports